export function filterAuctioneerUsers(users) {
  return (users || []).filter(function (user) {
    return user && typeof user.isAuctioneer === "function" && user.isAuctioneer();
  });
}

export function auctioneerDisplayName(user) {
  if (!user) {
    return "";
  }
  var given = user.givenName || "";
  var family = user.familyName || "";
  var name = (given + " " + family).trim();
  if (name.length > 0) {
    return name;
  }
  return user.email || user.accountId || "";
}
